import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LogoService } from '../../_services/logo.service';
import { environment } from '../../../environments/environment';

@Component( {
    selector: 'app-logo',
    templateUrl: './logo.component.html',
    standalone: true,
    imports: [CommonModule]
})
export class LogoComponent implements OnInit {
logo: any;
  @Input() hide = '';
  title = '';
  constructor(
    private logoServ: LogoService
  ) { }

  public ngOnInit() {
    this.title = environment.title;
    const self = this;
    this.logoServ.getCurrent().subscribe((logo: any) => {
      self.logo = logo;
    });
  }
}
